import React from "react";

import classnames from "classnames";

import { TitleMedium, TitleSmall } from "Cobalt/Header";
import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

export const bem = makeBem("Surface");
export const Surface = ({ className, ...rest }) => <Div className={classnames(bem(), className)} {...rest} />;
export const SurfaceHeader = ({ ...rest }) => (
  <Div p={5} className={bem("Header")}>
    <TitleMedium mt={0} mb={0} {...rest} />
  </Div>
);
export const SurfaceSection = ({ className, title, children, ...rest }) => (
  <Div p={5} className={classnames(bem("Section"), className)} {...rest}>
    {title && (
      <TitleSmall mt={0} mb={5}>
        {title}
      </TitleSmall>
    )}
    {children}
  </Div>
);
